import { default as theme } from './raccoonTheme.json';
/**
 * @param theme                Raccoon Theme Colors
 * @param theme.primary        Primary color
 * @param theme.secondary      Secondary color
 * @param theme.nemBlue        NEM blue
 * @param theme.nemGreen       NEM green
 * @param theme.nemOrange      NEM orange
 * @param theme.textSlightGray Slight Gray Text
 * @param theme.textDarkGray   Dark gray
 * @param theme.textLightGray  Light gray
 */
export default theme;
/*
const VuetifyDefault = {
  primary: '#1976D2',
  secondary: '#424242',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107'
};
 */



//////////////////
// WEBPACK FOOTER
// ./src/raccoonTheme.ts
// module id = 79
// module chunks = 1